'use strict';

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _configUtils = require('../utils/configUtils');

var _configUtils2 = _interopRequireDefault(_configUtils);

var _htmlUtils = require('../utils/htmlUtils');

var _slotEvents = require('./slotEvents');

var _slotEvents2 = _interopRequireDefault(_slotEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adSlotFactory = {
  createAdSlot: function createAdSlot(slotName, elementId, dimensions) {
    var slot = _configUtils2.default.getSlotDefinition(slotName);
    var formats = (0, _cloneDeep2.default)(_configUtils2.default.getFormatDefinitionsBySlotDefinition(slot));
    var filteredFormats = _configUtils2.default.filterFormatDefinitionsByDimensions(formats, dimensions);

    if (!slot || !filteredFormats || (0, _isEmpty2.default)(filteredFormats)) {
      return null;
    }

    var emitter = new _events2.default();
    return {
      elementId: elementId,
      name: slot.name,
      medium: filteredFormats[0].medium, // assume formats for a given slot are all of same medium
      formats: filteredFormats,
      isAdSlotVisible: function isAdSlotVisible() {
        return (0, _htmlUtils.isAdSlotVisible)(elementId);
      },
      refresh: function refresh() {
        emitter.emit(_slotEvents2.default.refresh, {});
      },
      on: emitter.on.bind(emitter),
      once: emitter.once.bind(emitter),
      off: emitter.removeAllListeners.bind(emitter)
    };
  }
};

module.exports = adSlotFactory;